import React from 'react';
import { PreApprovalMetricsProvider } from './context/PreApprovalMetricsContext';
import { WiseboardRefreshProvider } from './context/WiseboardRefreshContext';
import { PreApprovalTable } from './components/PreApprovalTable';
import { RecruitmentTable } from './components/RecruitmentTable';
import { DocumentProcessingTable } from './components/DocumentProcessingTable';
import { GPUStatsCards } from './components/GPUStatsCards';
import { WiseboardFilterBar } from './components/WiseboardFilterBar';
import { WorkerStatusBar } from './components/WorkerStatusBar';
import { DocumentExtractionHistory } from './components/DocumentExtractionHistory';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, UserPlus, FileSearch } from 'lucide-react';

export function WiseboardDashboard() {
  return (
    <WiseboardRefreshProvider>
      <PreApprovalMetricsProvider>
        <div className="space-y-6">
          {/* Header */}
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-foreground">Wiseboard</h1>
              <p className="text-muted-foreground">Real-time analytics dashboard</p>
            </div>
            <WiseboardFilterBar />
          </div>

          {/* Worker Status Bar */}
          <WorkerStatusBar />

          {/* Pre-Approvals Table */}
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg font-semibold flex items-center gap-2">
                <FileText className="h-5 w-5 text-blue-600" />
                Pre-Approvals by Loan Officer
              </CardTitle>
            </CardHeader>
            <CardContent>
              <PreApprovalTable />
            </CardContent>
          </Card>

          {/* Recruitment Table */}
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg font-semibold flex items-center gap-2">
                <UserPlus className="h-5 w-5 text-green-600" />
                Recruitment by Recruiter
              </CardTitle>
            </CardHeader>
            <CardContent>
              <RecruitmentTable />
            </CardContent>
          </Card>

          {/* Document Processing Section */}
          <Card>
            <CardHeader className="pb-2">
              <CardTitle className="text-lg font-semibold flex items-center gap-2">
                <FileSearch className="h-5 w-5 text-purple-600" />
                Document Extraction
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div>
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm font-medium text-muted-foreground">GPU performance</h3>
                  <span className="text-xs text-muted-foreground">All-time (ignores date filter)</span>
                </div>
                <GPUStatsCards />
              </div>
              <div>
                <h3 className="text-sm font-medium text-muted-foreground mb-2">By user (selected date range)</h3>
                <DocumentProcessingTable />
              </div>
            </CardContent>
          </Card>

          {/* Document Extraction History */}
          <DocumentExtractionHistory defaultCollapsed={true} />
        </div>
      </PreApprovalMetricsProvider>
    </WiseboardRefreshProvider>
  );
}

export default WiseboardDashboard;
